/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_Subtitles_Start_ToastInputs */

const en_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing subtitle events...`)
};

const fr_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des evenements de sous-titres...`)
};

const de_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelereignisse werden importiert...`)
};

const it_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione degli eventi dei sottotitoli...`)
};

const ru_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт событий субтитров...`)
};

const es_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando eventos de subtítulos...`)
};

const zh_cn2_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入字幕事件...`)
};

const ja_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕イベントをインポートしています...`)
};

const hi_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक इवेंट आयात किए जा रहे हैं...`)
};

const pt_pt2_editor_import_subtitles_start_toast = /** @type {(inputs: Editor_Import_Subtitles_Start_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando eventos de legenda...`)
};

/**
* | output |
* | --- |
* | "Importing subtitle events..." |
*
* @param {Editor_Import_Subtitles_Start_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_subtitles_start_toast = /** @type {((inputs?: Editor_Import_Subtitles_Start_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_Subtitles_Start_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_import_subtitles_start_toast(inputs)
	if (locale === "de") return de_editor_import_subtitles_start_toast(inputs)
	if (locale === "it") return it_editor_import_subtitles_start_toast(inputs)
	if (locale === "ru") return ru_editor_import_subtitles_start_toast(inputs)
	if (locale === "es") return es_editor_import_subtitles_start_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_import_subtitles_start_toast(inputs)
	if (locale === "ja") return ja_editor_import_subtitles_start_toast(inputs)
	if (locale === "hi") return hi_editor_import_subtitles_start_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_import_subtitles_start_toast(inputs)
	return en_editor_import_subtitles_start_toast(inputs)
});